import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { NamedAdapter } from 'shell-models-lib';
import { LibraryVariable } from '../base/libraryvariable';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(LibraryVariable)
})
export class LibraryVariableAdapter extends NamedAdapter<LibraryVariable, Model.LibraryVariableSpecification> {
    protected _toResource(variable: LibraryVariable): Model.LibraryVariableSpecification {
        const variableSpecification: Model.LibraryVariableSpecification = {
            type: variable._type,
            variableName: variable.variableName,
            libraryName: variable.libraryName
        };
        return variableSpecification;
    }

    protected _toModel(modelVariable: Model.LibraryVariableSpecification, variable?: LibraryVariable, variableName?: string, ownerType?: string, ownerName?: string): LibraryVariable {
        if (!variable) {
            variable = new LibraryVariable(variableName);
        }
        // _type is the type stored in our pipeline backend (e.g. 'Object', 'String', 'Bool').
        // _rawType is NOT set here — the pipeline backend doesn't store the upstream Variable Library artifact's
        // original type (e.g. 'ConnectionReference', 'ItemReference'). That comes from
        // LibraryVariablesService.getRawType() after calling fetchAndCacheLibraryVariables().
        variable._type = modelVariable.type;
        variable.variableName = modelVariable.variableName;
        variable.libraryName = modelVariable.libraryName;
        return variable;
    }
}
